declare global {
  interface Window {
    webkitAudioContext: typeof AudioContext
  }
}

const AudioContextClass: {
  new (): AudioContext
  prototype: AudioContext
} = window.AudioContext

export const audioCtx = new AudioContextClass()

export const playJump = () => {
  const osc = audioCtx.createOscillator()
  const gain = audioCtx.createGain()
  osc.type = 'square'
  osc.frequency.value = 400
  gain.gain.value = 0.2
  osc.connect(gain)
  gain.connect(audioCtx.destination)
  osc.start()
  osc.stop(audioCtx.currentTime + 0.1)
}

export const playBoom = () => {
  const osc = audioCtx.createOscillator()
  const gain = audioCtx.createGain()
  osc.type = 'square' // Changed to square for a more classic arcade sound
  osc.frequency.setValueAtTime(350, audioCtx.currentTime) // Start at a higher frequency
  osc.frequency.exponentialRampToValueAtTime(30, audioCtx.currentTime + 0.4) // Shorter, more aggressive drop
  gain.gain.setValueAtTime(1.0, audioCtx.currentTime) // Max volume for impact
  gain.gain.exponentialRampToValueAtTime(0.001, audioCtx.currentTime + 0.5) // Shorter duration
  osc.connect(gain)
  gain.connect(audioCtx.destination)
  osc.start()
  osc.stop(audioCtx.currentTime + 0.5) // Shorter overall duration
}

export const playScore = () => {
  const osc = audioCtx.createOscillator()
  const gain = audioCtx.createGain()
  osc.type = 'sine'
  osc.frequency.value = 600
  gain.gain.value = 0.1
  osc.connect(gain)
  gain.connect(audioCtx.destination)
  osc.start()
  osc.stop(audioCtx.currentTime + 0.1)
}

export const playNewRecord = () => {
  const osc = audioCtx.createOscillator()
  const gain = audioCtx.createGain()
  osc.type = 'square'
  gain.gain.setValueAtTime(0.25, audioCtx.currentTime)
  gain.gain.exponentialRampToValueAtTime(0.0001, audioCtx.currentTime + 1)
  osc.connect(gain)
  gain.connect(audioCtx.destination)
  osc.frequency.setValueAtTime(440, audioCtx.currentTime)
  osc.frequency.setValueAtTime(660, audioCtx.currentTime + 0.3)
  osc.frequency.setValueAtTime(880, audioCtx.currentTime + 0.6)
  osc.start()
  osc.stop(audioCtx.currentTime + 1)
}
